// Copyright 2026. WebPros International GmbH. All rights reserved.

// Should be synced with MAX_ADDITIONAL_DISK_COUNT_ON_SERVER from backend/api/v1/ComputeResourceVm/Models/Disk.php
export const MAX_ADDITIONAL_DISK_COUNT_ON_SERVER = 23;